import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import AuthShell from "@/components/feature/AuthShell";
import { supabase } from "@/lib/supabase";
import ResetPasswordForm from "@/pages/admin/login/components/ResetPasswordForm";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [hasSession, setHasSession] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    let active = true;
    supabase.auth
      .getSession()
      .then(({ data }) => {
        if (!active) return;
        setHasSession(Boolean(data.session));
        setChecking(false);
      })
      .catch(() => {
        if (active) setChecking(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const handleSubmit = async (password: string) => {
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const { error: updateError } = await supabase.auth.updateUser({ password });
      if (updateError) {
        setError(updateError.message);
        return;
      }
      setMessage("Contraseña actualizada correctamente. Te llevamos al panel…");
      setTimeout(() => navigate("/admin/panel", { replace: true }), 1400);
    } catch {
      setError("No pudimos actualizar la contraseña. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <Seo title="Restablecer contraseña" path="/auth/reset-password" robots="noindex, nofollow, noarchive" />
      {checking ? (
        <div className="flex flex-col items-center gap-3 py-10">
          <i className="ri-loader-4-line animate-spin text-3xl leading-none text-primary-500" aria-hidden="true"></i>
          <p className="text-sm text-foreground-600">Validando tu sesión…</p>
        </div>
      ) : hasSession ? (
        <ResetPasswordForm loading={loading} error={error} message={message} onSubmit={handleSubmit} />
      ) : (
        <div className="rounded-lg border border-background-200 bg-background-50 p-8 text-center">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700">
            <i className="ri-lock-2-line text-2xl leading-none" aria-hidden="true"></i>
          </span>
          <h1 className="mt-4 text-lg font-heading font-bold text-foreground-950">
            Enlace no válido o expirado
          </h1>
          <p className="mt-2 text-sm text-foreground-600">
            Por seguridad, los enlaces de recuperación caducan. Solicita uno nuevo para continuar.
          </p>
          <Link
            to="/admin/login"
            className="mt-6 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-label font-semibold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            Solicitar un enlace nuevo
          </Link>
        </div>
      )}
    </AuthShell>
  );
}